import { render, staticRenderFns } from "./sale-analysis.vue?vue&type=template&id=3a83630c&scoped=true&"
import script from "./sale-analysis.vue?vue&type=script&lang=js&"
export * from "./sale-analysis.vue?vue&type=script&lang=js&"
import style0 from "./sale-analysis.vue?vue&type=style&index=0&id=3a83630c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a83630c",
  null
  
)

export default component.exports